import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/legal/LegalPageLayout.jsx");
